export default function Header() {
  return (
    <div className="home-header">
      <a href="#">
        <img src="./Group 46.png" alt="contact" />
      </a>
      <div className="notify">
        <img src="moptro logo.png" alt="moptro" />
        <div>
          <p>4</p>
        </div>
      </div>
    </div>
  );
}
